import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'

import { Row, Col, FormControl, OverlayTrigger, Popover, Glyphicon } from 'react-bootstrap'

import AddMetadataType from './AddMetadataType'
import EditMetadataType from './EditMetadataType'

import { getMetadata, addMetadata, editMetadata, deleteMetadata } from '../../projects/reducers/manageProjects'
import { getProposalMetadata, addProposalMetadata, editProposalMetadata, deleteProposalMetadata } from '../../proposals/reducers/manageProposals'


class ManageMetadataTypes extends Component {

  state = {
    selectedClient: '',
    selectedModel: 'Project'
  }

  // componentDidMount() {
  //   this.props.getProjectMetadata()
  //   this.props.getProposalMetadata()
  // }

  handleChange = (e) => this.setState({ [e.target.name]: e.target.value })

  handleChangeClient = (e) => {
    const selectedClient = this.props.clients.find(client => client.id === e.target.value)
    if (selectedClient && selectedClient.subdomain === 'genesis') {
      this.setState({ selectedClient })
    } else if (selectedClient) {
      this.setState({ selectedClient, selectedModel: 'Project' })
    } else {
      this.setState({ selectedClient: '' })
    }
  }

  getMetadataProps = () => {
    if (this.state.selectedModel === 'Project') {
      return {
        metadata: this.props.projectMetadata.filter(meta => meta.client === this.state.selectedClient.url),
        route: 'metadata',
        addMetadata: this.props.addProjectMetadata,
        editMetadata: this.props.editProjectMetadata,
        deleteMetadata: this.props.deleteProjectMetadata,
      }
    } else if (this.state.selectedModel === 'Proposal') {
      return {
        metadata: this.props.proposalMetadata,
        route: 'proposal-metadata',
        addMetadata: this.props.addProposalMetadata,
        editMetadata: this.props.editProposalMetadata,
        deleteMetadata: this.props.deleteProposalMetadata,
      }
    }
  }

  render () {

    const { selectedClient, selectedModel } = this.state
    const { clients } = this.props


    const addMetadataPopover = (
      <Popover id='add-metadata-info-popover' title="Note">
        <p>
          Type determines which kind of input will appear on project pages and how its values will be managed.
        </p>

        <p>
          'Selectable Options' metadata will appear as a dropdown with selectable options. These options can be added, removed, or edited in the Manage Metadata Values section below.
        </p>

        <p>
          'User' metadata will appear as a dropdown with all users available as options. Users cannot be removed, but they can be added in the Add Users section below.
        </p>

        <p>
          'Date', 'Number', and 'Text' metadata will appear as normal date, number, or text inputs.
        </p>
      </Popover>
    )

    const editMetadataPopover = (
      <Popover id='edit-metadata-info-popover' title="Note">
        <p>
          Once created, a metadata's type cannot be changed, but its name can be edited and it can be deleted.
        </p>

        <p>
          Please note that deleting or editing a metadata will remove or alter the name of that option across <strong>all of your team's projects</strong>.
        </p>
      </Popover>
    )

    const clientOptions = clients.map(client => {
      if (client.managed_by_genesis === true) {
        return (
          <option key={client.id} value={client.id}>
            {client.name} {client.short_code}
          </option>
        )
      } else {
        return null
      }
    })

    return (
      <div id="ManageMetadataTypes">
        <Row>
          <Col xsHidden smHidden mdHidden lg={3}></Col>
          <Col xs={12} sm={12} md={12} lg={6}>
          <h5>Select Client</h5>
            <FormControl
              componentClass="select"
              name="selectedClient"
              onChange={this.handleChangeClient}
              selected={selectedClient}
            >
              <option value=""> - </option>
              {clientOptions}
            </FormControl>

            <br/>

            {this.state.selectedClient ?
              <Fragment>
                <h5>Select Model</h5>
                <FormControl
                  componentClass="select"
                  name="selectedModel"
                  onChange={this.handleChange}
                  value={selectedModel}
                >
                  <option value="Project">Projects</option>
                  {selectedClient && selectedClient.subdomain === 'genesis' ?
                    <option value="Proposal">Proposals</option>
                    :
                    null
                  }
                </FormControl>
              </Fragment>
              :
              null
            }

          </Col>
          <Col xsHidden smHidden mdHidden lg={3}></Col>
        </Row>
        <br/>
        {selectedClient ?
          <div>
            <div>
              <h4 style={{display: 'inline-block', marginRight: '10px'}}>
                Add {this.state.selectedModel} Metadata
              </h4>

              <OverlayTrigger
                style={{display: 'inline-block'}}
                trigger={["hover", "focus"]}
                placement="right"
                overlay={addMetadataPopover}
              >
                <Glyphicon glyph='info-sign' />
              </OverlayTrigger>

              <AddMetadataType
                selectedClient={selectedClient}
                selectedModel={selectedModel}
                {...this.getMetadataProps()}
              />
            </div>
            <hr/>
            <div>
              <h4 style={{display: 'inline-block', marginRight: '10px'}}>
                Edit {this.state.selectedModel} Metadata
              </h4>

              <OverlayTrigger
                style={{display: 'inline-block'}}
                trigger={["hover", "focus"]}
                placement="right"
                overlay={editMetadataPopover}
              >
                <Glyphicon glyph='info-sign' />
              </OverlayTrigger>

              <EditMetadataType
                selectedClient={selectedClient}
                selectedModel={selectedModel}
                {...this.getMetadataProps()}
              />
            </div>
          </div>
          :
          null
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    projectMetadata: state.manageProjects.metadata,
    proposalMetadata: state.manageProposals.proposalMetadata,
    clients: state.manageLogin.clients,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getProjectMetadata: (metadata) => dispatch(getMetadata(metadata)),
    addProjectMetadata: (metadata) => dispatch(addMetadata(metadata)),
    editProjectMetadata: (metadata) => dispatch(editMetadata(metadata)),
    deleteProjectMetadata: (metadata) => dispatch(deleteMetadata(metadata)),
    getProposalMetadata: (metadata) => dispatch(getProposalMetadata(metadata)),
    addProposalMetadata: (metadata) => dispatch(addProposalMetadata(metadata)),
    editProposalMetadata: (metadata) => dispatch(editProposalMetadata(metadata)),
    deleteProposalMetadata: (metadata) => dispatch(deleteProposalMetadata(metadata)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageMetadataTypes)



// WEBPACK FOOTER //
// ./src/routes/manager/components/ManageMetadataTypes.js